import Icon from '../components/Icon.vue'

Icon.register({
  'arrows-alt-v': {
    width: 256,
    height: 512,
    paths: [
      {
        d: 'M214.1 377.9H168V134.1H214.1C235.4 134.1 246.1 108.2 231 93.1L145 7C135.6-2.3 120.4-2.3 111 7L25 93.1C9.9 108.2 20.6 134.1 41.9 134.1H88V377.9H41.9C20.6 377.9 9.9 403.8 25 418.9L111 505C120.4 514.3 135.6 514.3 145 505L231 418.9C246.1 403.8 235.4 377.9 214.1 377.9z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/arrows-alt-v.js
// module id = NjEA
// module chunks = 144